import { editorConfig } from '~config';
import { getStatePure } from '~src/state';
import { exportIMG } from '~core';
import { v4 as uuidv4 } from 'uuid';
import { getMultiplier } from '~src/utils';

const getCanvasJson = (copyCurrentPage = true) => {
  if (
    window.canvas?.toJSON &&
    typeof window.canvas.toJSON === 'function' &&
    copyCurrentPage
  ) {
    return window.canvas.toJSON(editorConfig.additionalJsonProperties);
  } else {
    return {
      background: '#ffffff',
    };
  }
};

export const createEmptyPage = (copyCurrentPage = true) => {
  const pages = getStatePure('pages');
  const project = getStatePure('selected.tipo');
  const currentPageIndex = getStatePure('currentPageIndex');
  let dataPreview;

  if (copyCurrentPage) {
    dataPreview = exportIMG(
      0.92,
      project.outputDpi,
      'base64',
      'jpeg',
      true,
      getMultiplier()
    );
  }

  let newPage;
  if (
    pages &&
    pages.length &&
    typeof currentPageIndex !== 'undefined' &&
    pages[currentPageIndex] &&
    pages[currentPageIndex].preview
  ) {
    newPage = {
      temporaryId: uuidv4(),
      pageNumber: pages.length + 1,
      canvasJson: JSON.stringify(getCanvasJson(copyCurrentPage)),
      imgData: dataPreview,
      preview: pages[currentPageIndex].preview,
      order: pages.length + 1,
    };
  } else {
    newPage = {
      temporaryId: uuidv4(),
      pageNumber: 1,
      imgData: dataPreview,
      canvasJson: JSON.stringify(getCanvasJson(copyCurrentPage)),
      order: 0,
    };
  }

  return newPage;
};
